module.exports = __webpack_public_path__ + "static/media/5.3-eval.b54480ef.png";